import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { gql, withApollo } from 'react-apollo';
import { compose } from 'redux';
import analytics from '../site-render/src/lib/analytics';
import SiteThemeProvider from '../site-render/src/SiteThemeProvider';
import RegisterExtension from '../site-render/src/RegisterExtension';
import FullscreenLoading from './FullScreenLoading';
import { mapDispatchToProps as registerExtensionMapDisptachToProps } from '../site-render/src/redux/registerExtension';
import { mapDispatchToProps as couponSnackbarMapDispatchToProps } from '../site-render/src/redux/couponSnackbar';
import { connect } from 'react-redux';
import Dialog from '../site-render/src/Dialog';
import { FormattedMessage } from 'react-intl';
import Typography from '../site-render/src/Typography';

const publicEventQuery = gql`
  query publicEvent($eventId: String!, $language: Language!) {
    publicEvent(id: $eventId) {
      id
      name
      registrationLink
      mainLanguage
      languages
      registerEnabled
      registerHideBuyerFieldsOnFreeOrders
      registerForeignBuyerEnabled
      registerShowCouponField
      dateRange {
        start
        end
      }
      registerExtension(language: $language) {
        id
        type
        data
        styles
      }
      registerFormFieldIds
      registerPaymentForms {
        bankSlip {
          hiddenNextEvent
        }
        creditCard {
          installmentEnabled
        }
      }
    }
  }
`;

class Register extends Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
    eventId: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    openRegisterExtension: PropTypes.func.isRequired,
    closeRegisterExtension: PropTypes.func.isRequired,
    updateVisibility: PropTypes.func.isRequired,
  };

  state = {
    loading: true,
  };

  record = (name, props) => {
    const { eventId } = props;

    analytics.record(
      name,
      {
        event: { id: eventId },
      },
      eventId,
      true,
    );
  };

  recordInterest(info) {
    this.record('registrationClick', info);
  }

  recordPageView(props) {
    this.record('pageView', props);
  }

  componentDidMount() {
    window.addEventListener('message', this.onMessage, false);

    const jssStyles = document.getElementById('jss-server-side');
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }

    this.props.openRegisterExtension();
    this.props.updateVisibility(false);
    this.recordPageView(this.props);

    window.parent.postMessage('didLoadRegister', '*');
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessage, false);
  }

  onMessage = message => {
    if (message.data === 'openRegister') {
      this.onOpenRegister();
    } else if (message.data === 'didCloseRegister') {
      this.onDidCloseRegister();
    }
  };

  onOpenRegister = async () => {
    const { eventId, language, client } = this.props;

    try {
      const { data } = await client.query({
        query: publicEventQuery,
        variables: {
          eventId,
          language,
        },
        fetchPolicy: 'network-only',
      });

      if (data.publicEvent) {
        this.recordInterest({ eventId });
      }

      this.setState({
        loading: false,
        data,
      });
    } catch (error) {
      this.setState({ loading: false, error });
    }
  };

  onDidCloseRegister = async () => {
    this.props.openRegisterExtension();
    this.setState({ loading: true });
  };

  closeRegisterExtension = () => {
    this.setState({ error: undefined });
    this.props.closeRegisterExtension();
  };

  renderRegister() {
    const { language } = this.props;
    const { loading, data: { publicEvent } = {} } = this.state;

    if (loading) {
      return <FullscreenLoading />;
    }

    if (!publicEvent) {
      return null;
    }

    const { registerExtension } = publicEvent;

    return (
      <RegisterExtension
        event={publicEvent}
        site={{}}
        language={language}
        section={registerExtension}
        animateIn={false}
      />
    );
  }

  render() {
    const { error } = this.state;

    return (
      <SiteThemeProvider site={{}}>
        <Fragment>
          {this.renderRegister()}
          <Dialog
            open={Boolean(error)}
            onRequestClose={this.closeRegisterExtension}
            escToClose={true}
            closeInOverlay={true}
          >
            <Typography>
              <FormattedMessage id="genericError" />
            </Typography>
          </Dialog>
        </Fragment>
      </SiteThemeProvider>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...registerExtensionMapDisptachToProps(dispatch),
    ...couponSnackbarMapDispatchToProps(dispatch),
  };
}

export default compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
  withApollo,
)(Register);



// WEBPACK FOOTER //
// ./src/register/Register.js